<nav
  class="navigation-tab-bar"
  [ngClass]="distributionClass"
  [attr.aria-label]="'a11y.navigation_tab_bar.label' | translate"
>
  <ul class="navigation-tab-bar__list">
    <li
      *ngFor="let config of buttonsConfig"
      class="navigation-tab-bar__list-item"
    >
      <app-navigation-tab-bar-navigation-button
        *ngIf="!config.isConversion"
        [totalNotifications]="config.totalNotifications"
        [iconName]="config.iconName"
        [text]="config.text"
        [isActive]="config.isActive"
        [linkQueryParams]="config.queryParams"
        [linkRouter]="config.routerLink"
        [href]="config.href"
        (click)="handleClick(config)"
      ></app-navigation-tab-bar-navigation-button>

      <app-navigation-tab-bar-conversion-button
        *ngIf="config.isConversion"
        [iconName]="config.iconName"
        [ariaLabel]="config.conversionAriaLabel"
        [linkRouter]="config.routerLink"
        (click)="handleClick(config)"
      ></app-navigation-tab-bar-conversion-button>
    </li>
  </ul>
</nav>
